import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const RescheduleIcon = React.forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    width="24px"
    height="24px"
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="m5 1v2h-3v19h20v-19h-3v-2h-2v2h-10v-2zm-1 7h16v12h-16zm6 2-4 4 4 4v-3h4v3l4-4-4-4v3h-4z" />
    </>
  </SvgIcon>
));

export default RescheduleIcon;
